export const articles = [
  {
    slug: 'danfoss-industrial-valve-selection',
    title: '丹佛斯工业制冷控制阀怎么选型？',
    description: '从阀门功能、通径、控制方式、制冷剂兼容性和特殊工况五个维度梳理工业制冷控制阀选型流程。',
    category: '选型指南', updated: '2026-07-01', readTime: '约 10 分钟',
    intro: '控制阀选型不能只看管径。正确流程应从系统功能和工况出发，再通过官方选型工具核算容量与压降。',
    sections: [
      ['先确定阀门功能', ['检修隔离通常选用 SVA、STC 等截止阀。', '自动流量调节可考虑 ICM；紧凑型阀站可考虑 ICF；超压保护必须使用匹配工况的安全阀。', '蒸发器供液需要结合系统规模、控制精度和制冷剂选择热力、电子或电动方案。']],
      ['准备完整工况参数', ['至少需要制冷剂、制冷量、蒸发温度、冷凝温度、管径、压差和控制信号。', '管径只能用于初步判断，最终应通过 Danfoss Coolselector® 等官方工具核算。', 'CO₂系统压力等级高，不应套用常规氨或氟系统经验值。']],
      ['检查材料与压力等级', ['R717 氨系统应避免使用铜及铜合金部件。', 'R744 CO₂系统应确认亚临界或跨临界工况以及最大工作压力。', '低温、热气融霜和室外安装还要核对材料低温韧性、允许温度和防护等级。']],
      ['形成可审核的选型结果', ['输出型号、口径、功能模块、设计压力、控制信号和关键计算条件。', '工程实施前由项目设计方和设备供应方共同复核，不能以通用文章代替正式设计。']],
    ],
  },
  {
    slug: 'danfoss-valve-troubleshooting',
    title: '丹佛斯制冷控制阀常见故障与排查方法',
    description: '按照先系统、后线路、再阀体的顺序排查关不严、不动作、外漏、过滤器堵塞和膨胀阀调节异常。',
    category: '维护保养', updated: '2026-07-01', readTime: '约 11 分钟',
    intro: '现场所见的“阀门故障”经常来自系统脏堵、接线、供电或安装问题。排查应从低风险、可验证的项目开始。',
    sections: [
      ['阀门关不严或内漏', ['确认系统已经安全隔离和泄压，再检查流向、阀芯异物与密封面。', '优先排除异物和安装问题，再判断是否需要维修包或更换阀门。']],
      ['电动阀不动作', ['依次检查额定电源、控制信号、端子接线、屏蔽干扰和驱动器匹配。', '手动动作正常通常指向控制或信号问题；机械动作也异常时再检查阀芯和驱动机构。']],
      ['外部泄漏', ['氨系统泄漏应立即执行现场应急预案，禁止未经隔离泄压带压维修。', '根据泄漏位置检查阀杆密封、法兰垫片、阀盖 O 型圈或阀体损伤。']],
      ['预防性维护', ['建立月度外观、动作、指示灯和过滤器压差巡检。', '安全阀测试、密封件更换周期和扭矩要求应以制造商手册及法规为准。']],
    ],
  },
  {
    slug: 'expansion-valve-comparison',
    title: '热力膨胀阀、电子膨胀阀与电动膨胀阀怎么选？',
    description: '比较三类膨胀控制方案的工作原理、控制精度、系统成本、适用规模和运维要求。',
    category: '产品对比', updated: '2026-07-01', readTime: '约 9 分钟',
    intro: '三类阀门名称接近，但驱动方式和系统构成不同。不存在适用于所有项目的单一答案。',
    sections: [
      ['热力膨胀阀', ['利用感温包和膜片进行机械调节，无需电源和控制器。', '结构简单、成本较低，适合工况相对稳定且控制要求适中的系统。']],
      ['电子膨胀阀', ['通常与控制器、压力和温度传感器配合，通过脉冲或步进控制供液。', '适合负荷变化明显、需要远程监控或更精细控制的应用。']],
      ['电动调节方案', ['通过执行器和模拟或数字信号连续调节阀位，适用于较大口径和集中自动控制。', '选型需同时核对阀体、执行器、控制器和反馈信号。']],
      ['决策原则', ['比较全生命周期成本，而不是只比较单阀价格。', '同时评估控制精度、故障模式、运维能力、备件供应和系统安全要求。']],
    ],
  },
  {
    slug: 'why-use-automatic-air-purger',
    title: '制冷系统为什么要配置自动空气分离器？',
    description: '解释不凝性气体的来源、危害、判断方法，以及自动空气分离器相对手动放空的优势。',
    category: '技术科普', updated: '2026-07-01', readTime: '约 12 分钟',
    intro: '空气等不凝性气体会占用冷凝器换热面积并增加高压侧压力，是大型工业制冷系统常见但容易被忽略的效率问题。',
    sections: [
      ['不凝性气体从哪里来', ['安装或维修后抽真空不充分、充注操作、低压侧渗漏以及长期运行都可能引入空气。', '空气通常聚集在冷凝器或储液器高处。']],
      ['对系统的影响', ['可能造成冷凝压力和排气温度升高、制冷量下降、能耗增加以及运行波动。', '判断时应比较实测压力与对应制冷剂饱和温度，并排除冷凝器污染、风水量不足等其他原因。']],
      ['自动分离的价值', ['自动设备先冷凝回收混合气体中的制冷剂，再排出不凝性气体，可减少人工判断和制冷剂损失。', '设备选型取决于制冷剂、系统规模、放空点数量和控制集成需求。']],
      ['安全提醒', ['氨系统放空与维修必须由具备资质和防护条件的人员执行。', '具体安装位置、排放处理和联锁方式以制造商手册及项目设计为准。']],
    ],
  },
]

export const cases = [
  { slug: 'harbin-food-air-purger', title: '哈尔滨食品厂自动空分系统工程实例', description: '大型氨制冷系统冬季高排气压力的诊断与自动空分改造记录。', tags: ['自动空分', 'R717', '食品加工'], metrics: [['系统规模', '8 台螺杆机组'], ['改造前', '排气压力超过 14 bar'], ['资料记录结果', '降至 9 bar 以下']], sections: [['项目问题', '现场在低环境温度下仍出现异常高排气压力和机组保护。排查将不凝性气体积累作为主要方向。'], ['实施方案', '在高压侧设置自动空气分离装置，通过冷却混合气体、回收氨并自动排出不凝性气体。'], ['资料记录', '项目材料记录投运一夜后排气压力明显下降，机组恢复运行。具体数据仍应以原始调试记录复核。']], reviewNote: '客户名称未公开；性能数据发布前应复核调试记录。' },
  { slug: 'cr-snow-icf-valve-station', title: '华润雪花啤酒温州 ICF 组合阀工程实例', description: '发酵罐区氨直接冷却系统采用模块化 ICF 组合阀的工程应用。', tags: ['ICF', 'R717', '啤酒发酵'], metrics: [['项目规模', '64 只发酵罐'], ['阀组数量', '资料记录 256 套'], ['主要目标', '减少焊点并简化安装']], sections: [['工程挑战', '发酵温控精度高、罐区管路密集，氨系统还需要重点控制焊接点和潜在泄漏风险。'], ['方案特点', 'ICF 在一个阀体中组合截止、过滤、电磁或调节等功能模块，缩短阀组长度并降低现场连接复杂度。'], ['长期价值', '模块化结构便于维护和更换功能模块，全生命周期价值来自安装、检测、保温和维护等综合成本。']], reviewNote: '客户名称、数量及运行数据发布前应确认公开授权。' },
  { slug: 'wuxi-necharge-wet-dx', title: '无锡蔬菜冷库 NeoCharge 湿直喷工程实例', description: '6 台冷风机从传统热力膨胀控制调整为 NeoCharge 湿直喷控制的案例。', tags: ['NeoCharge', '湿直喷', '蔬菜冷库'], metrics: [['冷风机', '6 台'], ['温区', '0–8℃'], ['资料记录节能', '15% 以上']], sections: [['项目背景', '蔬菜冷库负荷波动明显，同时对温度和湿度稳定性有较高要求。'], ['控制方案', '每台冷风机采用独立控制器、加热式传感器和 AKV 执行元件，根据出口状态调节供液。'], ['资料记录', '项目材料记录库温波动缩小并取得节能效果；公开前仍需补充测量周期、基线和计量方法。']], reviewNote: '客户名称和节能数据发布前应获得授权并补充测量口径。' },
]

export const faqs = [
  ['选型需要提供哪些参数？', '建议提供制冷剂、蒸发温度、冷凝温度、制冷量、管径、设计压力和控制方式。参数不完整时只能进行初步判断。'],
  ['ICF 组合阀适合什么场景？', '适合希望减少现场焊点、缩短阀组长度并采用模块化维护的工业制冷阀站。具体模块组合需按功能和工况选定。'],
  ['阀门关不严是否一定需要更换？', '不一定。安全隔离和泄压后，应先检查流向、异物、阀芯及密封面，再决定清理、使用维修包或更换。'],
  ['电动阀不动作如何排查？', '先确认电源，再检查控制信号、接线和驱动器匹配，最后检查机械卡阻。涉及带压系统时不要擅自拆卸。'],
  ['氨系统可以使用铜阀件吗？', '一般不应使用铜及铜合金与氨直接接触，最终材料选择必须遵循设备资料、设计规范和项目要求。'],
  ['CO₂系统可以使用普通制冷阀吗？', '应使用满足对应压力等级和温度范围的 CO₂专用产品，并区分亚临界和跨临界工况。'],
  ['热力膨胀阀和电子膨胀阀如何选择？', '工况稳定、控制简单时可考虑热力膨胀阀；负荷变化大、需要远程监控或更精细控制时可评估电子方案。'],
  ['什么是不凝性气体？', '主要指在系统冷凝条件下不能冷凝的空气、氮气等气体，可能导致冷凝压力升高和换热效率下降。'],
  ['如何判断系统中可能有空气？', '可比较实测压力与制冷剂饱和温度关系，但还需排除冷凝器污堵、冷却不足和仪表误差。'],
  ['自动空气分离器需要维护吗？', '需要定期检查过滤器、电磁阀、独立制冷回路、密封性和报警记录，周期应按制造商手册确定。'],
  ['可以提供阀门选型支持吗？', '可以。请准备项目工况参数，通过电话 15372829178 或邮箱 phonetoo@126.com 联系。'],
  ['技术文章能否代替工程设计？', '不能。网站内容用于知识交流和初步选型，正式项目须由具备相应能力的设计与工程人员审核。'],
]
